/** @format */

import React from "react";
import { Link } from "react-router-dom";
import Truncate from "../truncate/truncate";
import ReactHtmlParser from "react-html-parser";
import { removeSpaces } from "../helpers/arrayHelpers";
export default function ContentCardWide(props) {
  const { cover_image, description, title, id } = props.data;
	return (
		<Link
			className="m-auto"
			about="news"
			to={`/view/news/${id}?title=${removeSpaces(title)}`}
		>
			<div className=" py-2 md:w-[260px] lg:w-[275px] w-[300px] shadow-lg h-[26rem] dark:bg-dark-500 rounded-xl overflow-hidden">
				<img
					loading="lazy"
					src={cover_image}
					alt="anime"
					className="w-full object-cover h-60"
				/>
				<div className="p-2">
					<p className="h-10 p-1 truncate  dark:text-gray-300 font-semibold  text-center">
						{title}
					</p>

					<Truncate
						className=" font-extralight font-ubuntu"
						lines={3}
						ellipsis={<span className="font-bold">...More</span>}
					>
						{ReactHtmlParser(description)}
					</Truncate>
				</div>
			</div>
		</Link>
	);
}
